import { SET_QUICK_ADD_FOLDER, RESET_QUICK_ADD_FOLDER } from '../actions/quickAddFolder';

export default function quickAddFolder(state = null, action) {
    switch (action.type) {
        case SET_QUICK_ADD_FOLDER:
            return action.folder;
        case RESET_QUICK_ADD_FOLDER:
            return null;
        default:
            return state;
    }
}
